import { render, staticRenderFns } from "./Karin-menu.vue?vue&type=template&id=8bd0985e"
import script from "./Karin-menu.vue?vue&type=script&lang=js"
export * from "./Karin-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports